import { Component, OnInit, ViewChild } from '@angular/core';
import { MassCommService, Message, MessageQueueSearch } from '../../shared/index';
import { Router } from '@angular/router';
import { Table as PrimeDataTable } from 'primeng/table';
import { NotificationService, PagedResultGeneric } from '../../../shared/index';
import { TranslationService } from '../../../shared/translation/translation.service';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { DatagridService } from '../../../shared/index';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { debounce } from 'lodash-decorators';
import { MenuItem } from 'primeng/api';

/**
 * admin mass comm message drafts
 */
@Component({
  selector: 'wl-mass-comm-message-admin-drafts',
  templateUrl: 'mass-comm-message-admin-drafts.component.html',
  styleUrls: [],
  providers: [],
    standalone: false
})
export class MassCommMessageAdminDraftsComponent extends LazySelectableTableComponent<MessageQueueSearch, Message> implements OnInit {
  @ViewChild('draftsGrid', { static: false }) private _draftsGrid: PrimeDataTable;

  public isBusy: boolean = false;
  public isSearching: boolean = false;
  public deleting: boolean = false;
  public draftsResult: PagedResult<Array<Message>> = new PagedResult<Array<Message>>([]);
  public showModal = false;
  public rowMenuItems = new Map<number, any[]>();
  private _messageToDelete: Message;

  /**
   * inject
   * @param _massCommService
   */
  public constructor(
    private _massCommService: MassCommService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _router: Router,
    public datagridService: DatagridService
  ) {
    super('MessageId', datagridService);
    this.searchParams = new MessageQueueSearch();
  }

  fetchResults(): Promise<PagedResultGeneric<Message>> {
    return this._massCommService.searchDrafts(this.searchParams);
  }

  @debounce(500)
  filterChanged() {
    this.searchParams.PageNumber = 1;
    this.getDrafts();
  }

  /**
   * on init
   */
  public ngOnInit(): void {}

  /**
   * start a search
   */
  public startSearch(): void {
    this._draftsGrid.reset();
  }

  /**
   * for the ngprime data table
   */
  public lazyLoadMessageDrafts($event: any): void {
    this.datagridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    if (!this.isSearching) this.getDrafts();
  }

  /**
   * actually load draft messages
   */
  public getDrafts() {
    if (this.isSearching) return;
    this.isSearching = true;
    this.searchParams.Recurring = false;
    this.searchParams.Scheduled = false;

    this.fetchResults().then(
      (result: PagedResult<Array<Message>>) => {
        this.datagridService.mapPagedResultsToPagedSearch(result, this.searchParams);
        this.draftsResult = result;
        this.isSearching = false;
      },
      () => {
        this.isSearching = false;
      }
    );
  }

  /**
   * copy a given message
   */
  public copyMessage(message: Message): void {
    if (this.isBusy || !message) return;
    this._router.navigate(['communications/message/draft/copy', message.MessageId]);
  }

  /**
   * edit a given message
   */
  public editMessage(messageId: number): void {
    if (!messageId) return;

    this._router.navigate(['communications/message/draft', messageId]);
  }

  /**
   * prompt before deleting
   */
  public confirmDeleteMessage(message: Message): void {
    if (this.deleting || !message || !message.MessageId) return;

    this._messageToDelete = message;

    this.showModal = true;
  }

  /**
   * delete a given message
   */
  public deleteMessgeConfirmed(): void {
    if (this.deleting || !this._messageToDelete) return;

    this.deleting = true;

    this._massCommService.deleteDraftMessage(this._messageToDelete.MessageId).then(
      () => {
        this.deleting = false;

        this._translationService.getTitlecase('communications.mass-comm-message-admin.message-deleted').then((message: string) => {
          this._notificationService.success(message);
        });

        this.showModal = false;

        this.getDrafts();
      },
      () => {
        this.deleting = false;
      }
    );
  }

  actionItems(message: Message): MenuItem[] {
    if (!this.rowMenuItems.has(message.MessageId)) {
      this.rowMenuItems.set(message.MessageId, [
        {
          label: this._translationService.getInstantTitlecase('common.copy'),
          icon: 'glyphicon glyphicon-duplicate',
          command: () => {
            this.copyMessage(message);
          }
        },
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          icon: 'glyphicon glyphicon-edit',
          command: () => {
            this.editMessage(message.MessageId);
          }
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          icon: 'glyphicon glyphicon-trash',
          command: () => {
            this.confirmDeleteMessage(message);
          }
        }
      ]);
    }
    return this.rowMenuItems.get(message.MessageId);
  }
}
